import React, { useCallback } from 'react';

import { Flex, HStack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { Controller } from 'react-hook-form';

import { Checkbox, Input } from 'components';
import { Datepicker } from 'components/Datepicker';
import { FrequencyTypes } from 'enums/types';

export default function FrequencyForm({
  frequency, register, setValue, withoutOverdue, control,
}:any) {
  const StartDate = useCallback(({ label = 'Data de inicio' }) => (
    <HStack
      spacing={4}
      width="100%">
      <Controller
        name="info.startDate"
        control={control}
        rules={{
          onChange(event) {
            if (event.target.value.length >= 10) {
              const format = event.target.value.length === 10 ? 'DD/MM/YYYY' : undefined;
              const date = dayjs(event.target.value, format);
              if (date.isValid()) {
                setValue('info.startDate', date);
              }
            }
          },
        }}
        render={({ field }) => (
          <Datepicker
            tooltip="Data da primeira execução"
            label={label}
            placeholder="00/00/0000"
            {...field}
          />
        )}
      />
      {!withoutOverdue && (
      <Input
        label="Tolerância de atraso"
        {...register('info.maxOverdue')}
        placeholder="Tolerância máxima de atraso (em minutos)"
      />
      )}
    </HStack>
  ), []);

  const week = Array.from({ length: 7 }).map((_empty, index) => (dayjs().day(index).format('dddd')));
  if (frequency === FrequencyTypes.Weekly) {
    return (
      <Flex flexDir="column">
        <Flex
          flexDir="column">
          <Text
            color="gray.600"
            variant="smallSemiBold"
            mb={4}>Selecione os dias da semana:
          </Text>
          <Flex
            mb={7}
            justify="space-between"
            flexWrap="wrap">
            {week.map((label, index) => (
              <Checkbox
                key={`checkbox-${label}-${index}`}
                viewProps={{ w: '33%' }}
                textColor="gray.600"
                value
                borderColor="gray.500"
                {...register(`day.${index}`)}
                pb={2}>
                {label}
              </Checkbox>
            ))}
          </Flex>
        </Flex>
        <StartDate />
      </Flex>
    );
  }

  return (
    <Flex
      flexDir="row">
      <StartDate />
    </Flex>
  );
}
